import { register } from '../../core/bootstrapper';
import { init as wishlistInit } from '../../../home24-shared/layout/header/wishlist';
import { init as headerCartInit } from './cart';
import userAccountInit from './userAccount';

register(null, () => {
    userAccountInit();
    headerCartInit();
    wishlistInit();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/header/headerBootstrap.js
 **/